import { StyleSheet, View } from "react-native";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { paddingXL } from "src/styles/spacing";
import { Text } from "src/swsh-native";

const CommentsUnreadIndicator = () => {
	const { theme } = useStyle();

	return (
		<View
			style={{
				marginTop: paddingXL,
				width: "100%",
				flexDirection: "row",
				alignItems: "center",
				paddingHorizontal: "8%",
				columnGap: paddingXL,
				justifyContent: "space-between",
			}}
		>
			<View
				style={{
					height: StyleSheet.hairlineWidth,
					flex: 1,
					backgroundColor: color.Divider[theme],
				}}
			/>
			<Text
				bold
				style={{
					marginHorizontal: "8%",
				}}
			>
				New
			</Text>
			<View
				style={{
					height: StyleSheet.hairlineWidth,
					flex: 1,
					backgroundColor: color.Divider[theme],
				}}
			/>
		</View>
	);
};
export default CommentsUnreadIndicator;
